import styled, { css, RuleSet } from 'styled-components'

import { AvatarShapeKeys, AvatarSizeKeys } from './avatar.types'

export const Avatar = styled.div<{ $size: AvatarSizeKeys; $shape: AvatarShapeKeys }>(
  ({ theme, $size, $shape }) => {
    const sizeStyles: Record<AvatarSizeKeys, RuleSet> = {
      large: css`
        width: 7.2rem;

        svg {
          width: 2.4rem;
        }

        span {
          font-size: 2.8rem;
        }
      `,
      medium: css`
        width: 4rem;

        svg {
          width: 2rem;
        }

        span {
          font-size: 1.6rem;
        }
      `,
      small: css`
        width: 3.2rem;

        svg {
          width: 2rem;
        }

        span {
          font-size: 1.3rem;
        }
      `,
    }

    const shapeStyles: Record<AvatarShapeKeys, RuleSet> = {
      circle: css`
        border-radius: ${theme.border.radius.circle};
        background-color: ${theme.colors.gray400};
      `,
      square: css`
        border-radius: ${theme.border.radius['8']};
        background-color: ${theme.colors.gray200};
      `,
    }

    return css`
      aspect-ratio: 1 / 1;
      display: grid;
      place-items: center;
      flex-shrink: 0;
      overflow: hidden;
      position: relative;
      ${sizeStyles[$size]};
      ${shapeStyles[$shape]};

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      svg {
        aspect-ratio: 1 / 1;
        color: ${theme.colors.black};
      }
    `
  },
)

export const Initials = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-weight: 600;
  line-height: 1;
  user-select: none;
`
